import { FEATURES, SEARCH_GROUPS } from '@/src/constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/eventos',
    name: 'events',
    redirect: 'eventos/',
    meta: {
      can_show: FEATURES.EVENTOS,
      search: {
        title: 'Eventos',
        description: 'Gestão e acompanhamento de eventos',
        keywords: ['eventos', 'agenda', 'prospecção', 'encontros'],
        icon: 'calendar-check',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(import('@modules/eventos/views/nav-bar/view-nav-bar.vue')),
    children: [
      {
        path: '/',
        name: 'events.prospect',
        meta: {
          can_show: FEATURES.EVENTOS,
          permission: ['all'],
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/eventos/views/overview-eventos/view-overview-eventos.vue'
            )
          ),
      },
      {
        path: 'configurar-eventos',
        name: 'events.manager',
        meta: {
          can_show: FEATURES.EVENTOS_GESTOR,
          permission: ['all'],
          search: {
            title: 'Configurações de eventos',
            description: 'Criar e configurar eventos',
            keywords: ['eventos', 'configurar', 'gestor', 'criar'],
            group: SEARCH_GROUPS.FERRAMENTAS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/eventos/views/manager-events/view-manager-events.vue'
            )
          ),
      },
    ],
  },
]
